import moment from "moment";

import template from "./pControllingExport.html";

export function pControllingExportDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pControllingExportController,
    controllerAs: 'pControllingExport',
    bindToController: true
  };

  return directive;
}

class pControllingExportController {
  constructor($interval, $scope, Auth, Controlling, DownloadFile, Notes, ConnectionQuality) {
    'ngInject';
    this.DownloadFile = DownloadFile;
    this.Auth = Auth;
    this.Controlling = Controlling;
    this.Notes  = Notes;
    this.ConnectionQuality = ConnectionQuality;

    this.dateStartChoice = moment().subtract(1, "month").format("YYYY-MM-DD");
    this.dateEndChoice = moment().format("YYYY-MM-DD");
    this.updateStartDate();

    this.allTeamsSelected = true;
    this.allFieldsSelected = true;

    this.state = "loading";
    this.Auth.authorize().then(
      (user) => {
        this.user = user;
        this.Controlling.getTeams().then(
          (success) => {
            this.state = "loaded";
            this.teams = success.data.filter(team => !team.archivedAt).filter(team => this.user.teamId == "49a6dcff-c4e6-443e-9627-597070a68c8e" ? true : team.name != "Team Iterators");
            this.teams.map((team) => {
              team.selected = true;
            });
            this.updateQuery();
          },
          (error) => {
            this.state = "loaded";
            this.error = error;
          }
        );

        this.Controlling.getAvailableReportFields().then((success) => {
          this.fields = success.data;
          this.fields.map( field => {
            if(field.field === "OutputType") {
              const language = localStorage.getItem("roedl-language");
              if (language === "de_DE")
                field.name = "Leistung";
              else
                field.name = "Output";
              return field;
            }
            return field;
          });
          this.fields.map((field) => {
            field.selected = true;
          });
          this.updateQuery();
          this.state = "loaded";
        }, (error) => {
          this.state = "loaded";
          this.error = error;
        });
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    this.timeout = $interval(() => {
      this.notes = Notes.getNotes();
    }, 10);

    $scope.$on("$destroy", () => {
      $interval.cancel( this.timeout );
    });

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  updateStartDate() {
    this.dateStart = moment(this.dateStartChoice);
    this.dateEnd = moment(this.dateEndChoice);
    if(this.dateEnd.unix() < this.dateStart.unix()) {
      this.dateEnd = this.dateStart;
      this.dateEndChoice = this.dateEnd.format("YYYY-MM-DD");
    }
  }

  updateEndDate() {
    this.dateStart = moment(this.dateStartChoice);
    this.dateEnd = moment(this.dateEndChoice);
    if(this.dateEnd.unix() < this.dateStart.unix()) {
      this.dateStart = this.dateEnd;
      this.dateStartChoice = this.dateEnd.format("YYYY-MM-DD");
    }
  }

  selectAllTeams() {
    this.teams.forEach(c => {
      if (this.allTeamsSelected) {
        c.selected = true;
      } else {
        c.selected = false;
      }
    });
    this.updateQuery();
  }

  selectAllFields() {
    this.fields.forEach(c => {
      if (this.allFieldsSelected) {
        c.selected = true;
      } else {
        c.selected = false;
      }
    });
    this.updateQuery();
  }

  updateQuery(){
    if(!this.teams || !this.fields) return;
    this.selectedTeams = this.teams.filter(({selected}) => selected);
    this.selectedFields = this.fields.filter(({selected}) => selected);

    if (this.allTeamsSelected && this.teams.find(t => t.selected != true)) {
      this.allTeamsSelected = false;
    }
    if (!this.allTeamsSelected && this.teams.every(t => t.selected == true)) {
      this.allTeamsSelected = true;
    }
    if (this.allFieldsSelected && this.fields.find(t => t.selected != true)) {
      this.allFieldsSelected = false;
    }
    if (!this.allFieldsSelected && this.fields.every(t => t.selected == true)) {
      this.allFieldsSelected = true;
    }
  }

  download() {
    this.state = "loading";
    this.error = undefined;
    this.updateEndDate();
    this.updateStartDate();
    this.updateQuery();
    this.Controlling.downloadBigReport(this.selectedTeams.map(({id}) => id), this.selectedFields.map(({field}) => field), this.dateStart.format("YYYY-MM-DD"), this.dateEnd.format("YYYY-MM-DD")).then((success) => {
      this.DownloadFile.downloadFromResponse(
        success,
        success.headers("content-type"),
        `klix_export_${this.dateStartChoice}_${this.dateEndChoice}_${moment().unix()}.xlsx`
        );
      this.state = "loaded";
    }, (error) => {
      this.state = "loaded";
      this.error = error;
    });
  }

}
